import { Button } from "@bokio/designsystem/components/Button/Button";
import Icon from "@bokio/designsystem/components/Icon/Icon";
import { Div, Paragraph, TextSpan } from "@bokio/designsystem/components/TypographicElements/TypographicElements";
import BankLangFactory from "@bokio/lang/BankLangFactory";

import type { FC } from "react";

import * as styles from "./signAndPayLoginGate.scss";

interface SignAndPayLoginGateProps {
	onAuthenticate: () => void;
}

export const SignAndPayLoginGate: FC<SignAndPayLoginGateProps> = ({ onAuthenticate }) => {
	const bankLang = BankLangFactory();

	return (
		<div className={styles.container}>
			<Div bumpHeadingLevel>
				<div className={styles.card}>
					<div className={styles.headingRow}>
						<span className={styles.heading}>
							<TextSpan style="large-heading">{bankLang.SignAndPayContextualGate_Heading}</TextSpan>
						</span>
						<Icon name="bba-filled" size="24" noMargin />
					</div>
					<Paragraph style="body-default" color="ui-2">
						{bankLang.SignAndPayContextualGate_Description}
					</Paragraph>
					<div className={styles.cta}>
						<Button icon="bankid-solid" onClick={onAuthenticate} testId="SignAndPayContextualGate_Authenticate">
							{bankLang.SignAndPayContextualGate_LoginWithBankID}
						</Button>
					</div>
				</div>
			</Div>
		</div>
	);
};
